import { UIElementContentSource } from '@smart-tv/hooks/use-ui-element-content/use-ui-element-content';
import { UIElement, UIElementStyle, UniverseSortingValue } from '@smart-tv/typings/content';

import { kmmRequest } from './kmm';

interface RawGenre {
  StofaMainGenreId: string | number;
  GenreName: string;
  ImageType: string;
  StofaSubGenreId?: string | number;
}

interface RawResponse {
  Genres: RawGenre[];
}

const responseMapper = (
  genres: RawGenre[],
  universeId: number,
  providerCollectionId: number
): UIElement[] =>
  genres.map((genre, index) => ({
    id: Number(genre.StofaMainGenreId) * 10 + index,
    title: genre.GenreName,
    style: genre.ImageType.toUpperCase() as UIElementStyle,
    contentSource: UIElementContentSource.Provider,
    providerContentProps: {
      universeId,
      providerCollectionId,
      subGenreId: genre.StofaSubGenreId ? Number(genre.StofaSubGenreId) : 0,
      mainGenreId: Number(genre.StofaMainGenreId),
      sortingType: UniverseSortingValue.NEWEST,
      itemLimit: 30
    }
  }));

export async function getProviderCollectionContentGenres(
  providerCollectionId: number,
  universeId: number
): Promise<UIElement[]> {
  const jsonResponse = await kmmRequest('getProviderCollectionContentGenres', {
    providerCollectionId,
    universeId
  });
  const response = JSON.parse(jsonResponse) as RawResponse;
  return responseMapper(response.Genres, universeId, providerCollectionId);
}

export default getProviderCollectionContentGenres;
